import ModalCompanies from './ModalCompanies'

export default ModalCompanies
